module.exports = __webpack_public_path__ + "img/colorpickericon.e12ab239.png";